// src/config/environment.js

// 環境に応じて開発モードを判定
export const isDevelopment = import.meta.env.DEV;

// 開発環境の設定
const devConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// 本番環境の設定
const prodConfig = {
    apiKey: "AIzaSyBVikBDfIKWYX6tmaf-A007dRAeV7qRnKA",
    authDomain: "suisui-e6260.firebaseapp.com",
    projectId: "suisui-e6260",
    storageBucket: "suisui-e6260.firebasestorage.app",
    messagingSenderId: "312150499234",
    appId: "1:312150499234:web:c5c5c70375e352c738dcfb",
    measurementId: "G-NVT81QD044"
};

// 環境に応じて設定を選択
export const firebaseConfig = import.meta.env.DEV ? devConfig : prodConfig;

// デバッグログは削除（セキュリティのため）

// 環境に応じたドメイン設定
export const appDomain = import.meta.env.DEV
    ? (import.meta.env.VITE_APP_DOMAIN || 'http://localhost:5174')
    : 'https://suisui.life';

export const publicContentDomain = import.meta.env.DEV
    ? (import.meta.env.VITE_PUBLIC_CONTENT_DOMAIN || 'http://localhost:5174')
    : 'https://suisui.life';